export const catalogRequestSucceeded = result => result?.success === 1;

export const canUseCatalogBootstrap = (bootstrap, shopID, goodsRequestKey, checkedGoodsRequestKey) => (
    checkedGoodsRequestKey === null
    && bootstrap?.goods === true
    && bootstrap.shopid === String(shopID)
    && goodsRequestKey === JSON.stringify([0, '0', '', String(shopID), 0])
);

export const canShowEmptyCatalog = (hasCheckedGoods, goodsCount) => (
    hasCheckedGoods === true && goodsCount === 0
);
